/**
 * ChoiceButtons — reemplazo de un <select> por botones clickeables (más
 * rápido y claro). Para conjuntos de opciones pequeños.
 *
 *   value, onChange  — estado controlado
 *   options          — [{ value, label, hint? }]
 *   columns          — nº fijo de columnas (si se omite, auto-fit)
 */
export function ChoiceButtons({ value, onChange, options, columns }) {
  return (
    <div
      className="grid gap-2"
      style={{
        gridTemplateColumns: columns
          ? `repeat(${columns}, minmax(0, 1fr))`
          : 'repeat(auto-fit, minmax(120px, 1fr))',
      }}
    >
      {options.map((o) => {
        const active = o.value === value
        return (
          <button
            key={o.value}
            type="button"
            onClick={() => onChange(o.value)}
            className="press"
            style={{
              padding: '12px 14px',
              borderRadius: 12,
              cursor: 'pointer',
              textAlign: 'center',
              fontSize: 14,
              fontWeight: 700,
              lineHeight: 1.2,
              border: active ? '2px solid #033021' : '1.5px solid #E6EFE3',
              background: active ? '#E3F0D5' : '#fff',
              color: '#143A22',
            }}
          >
            {o.label}
            {o.hint != null && (
              <div style={{ fontSize: 12, fontWeight: 500, color: '#5C6B60', marginTop: 2 }}>
                {o.hint}
              </div>
            )}
          </button>
        )
      })}
    </div>
  )
}
